namespace GeniuzPOS.Lookups {
    export interface VwpsShopTypeRow {
        Id?: number;
        ShopTypeId?: string;
        ShopTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace VwpsShopTypeRow {
        export const idProperty = 'ShopTypeId';
        export const nameProperty = 'ShopTypeId';
        export const localTextPrefix = 'Lookups.VwpsShopType';
        export const lookupKey = 'VwpsShopTypeRow';

        export function getLookup(): Q.Lookup<VwpsShopTypeRow> {
            return Q.getLookup<VwpsShopTypeRow>('VwpsShopTypeRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ShopTypeId = "ShopTypeId",
            ShopTypeName = "ShopTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
